import React from 'react';
import { RotateCcwIcon } from 'lucide-react';
import { preparationTasks } from '../../data/landing';
export function ProblemSection() {
  return <section className="bg-cream py-12 sm:py-24" data-id="element-292" data-mp="n8wquayrm958">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-293" data-mp="8lbr8r13ms22">
        <div className="mx-auto max-w-2xl text-center" data-id="element-294" data-mp="8ipjaqaaqajb">
          <h2 className="font-serif text-[1.9rem] leading-tight text-petrol-800 text-balance sm:text-5xl" style={{
          fontSize: "28px"
        }} data-id="element-295" data-mp="dj4xtl6bdo2v">
            ¿Cuánto tiempo se te va preparando <span className="italic text-terra-500" data-id="element-296" data-mp="3lgzkl9i1yfy">cada consulta?</span>
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-ink/75 sm:mt-6 sm:text-lg" data-id="element-297" data-mp="3lrbs2tiwt1vk">
            Si trabajás con sexualidad, muchas veces el problema <strong className="text-petrol-800" data-id="element-298" data-mp="3qrhmghgkd2hc">no es saber qué trabajar</strong>.
            Es todo el tiempo que lleva convertir ese conocimiento en una consulta concreta.
          </p>
        </div>

        <ul className="mx-auto mt-7 grid max-w-3xl grid-cols-2 gap-px overflow-hidden rounded-2xl bg-beige-200 sm:mt-12 sm:grid-cols-3" data-id="element-299" data-mp="1oy0gdi8309op">
          {preparationTasks.map(({
          label,
          icon: Icon
        }) => <li key={label} className="flex items-center gap-2.5 bg-cream px-3 py-3 sm:gap-3 sm:px-6 sm:py-5" data-id="element-300" data-mp="1io8b7nlzx672">
              <Icon className="h-4 w-4 shrink-0 text-sage-700 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-301" data-mp="1wfd2o2f7ms6b" />
              <span className="text-sm font-medium text-petrol-800 sm:text-base" data-id="element-302" data-mp="1sfcp0jzxql0b">{label}.</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-5 flex max-w-xl items-start justify-center gap-2 text-center text-sm text-ink/70 sm:mt-8 sm:items-center sm:text-base" data-id="element-303" data-mp="zpvqr5pmw9w6">
          <RotateCcwIcon className="mt-0.5 h-4 w-4 shrink-0 text-terra-500 sm:mt-0" aria-hidden="true" data-id="element-304" data-mp="1dqg960rn03p5" />
          Y terminás haciendo una y otra vez el mismo trabajo desde cero.
        </p>

        <div className="mx-auto mt-8 max-w-3xl rounded-2xl bg-petrol-800 px-5 py-7 text-center sm:mt-14 sm:px-12 sm:py-10" data-id="element-305" data-mp="2p3se6ez4uscw">
          <p className="font-serif text-xl leading-snug text-cream sm:text-4xl" data-id="element-306" data-mp="2k5h90hjs9610">
            El problema no es tu formación.
            <br data-id="element-307" data-mp="1mre3scqb6sth" />
            <span className="text-terra-300" data-id="element-308" data-mp="1mqw9vmr4cqoq">Es todo el tiempo que te lleva preparar el material.</span>
          </p>
        </div>
      </div>
    </section>;
}